import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "automatic": {
      "column": {
        "default": "1",
        "name": "automatic",
        "null": false,
        "type": "boolean"
      },
      "name": "automatic",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "droppable_record_id": {
      "column": {
        "default": null,
        "name": "droppable_record_id",
        "null": true,
        "type": null
      },
      "name": "droppable_record_id",
      "selected_by_default": null,
      "translated": null
    },
    "droppable_record_type": {
      "column": {
        "default": null,
        "name": "droppable_record_type",
        "null": true,
        "type": "string"
      },
      "name": "droppable_record_type",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "string_value": {
      "column": {
        "default": null,
        "name": "string_value",
        "null": true,
        "type": "text"
      },
      "name": "string_value",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "variable_type": {
      "column": {
        "default": "string",
        "name": "variable_type",
        "null": false,
        "type": "string"
      },
      "name": "variable_type",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "EmailTemplatePreviewLiquidVariable",
  "collectionKey": "email_template_preview_liquid_variables",
  "collectionName": "email_template_preview_liquid_variables",
  "i18nKey": "email_template_preview_liquid_variable",
  "camelizedLower": "emailTemplatePreviewLiquidVariable",
  "name": "EmailTemplatePreviewLiquidVariable",
  "nameDasherized": "email-template-preview-liquid-variable",
  "pluralName": "email_template_preview_liquid_variables",
  "ransackable_associations": [
    {
      "className": "EmailTemplatePreviewLiquidVariable::Audit",
      "collectionName": "email_template_preview_liquid_variable_audits",
      "foreignKey": "email_template_preview_liquid_variable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "EmailTemplatePreviewLiquidVariableAudit",
      "through": null
    },
    {
      "className": "EmailTemplatePreviewLiquidVariable::Audit",
      "collectionName": "email_template_preview_liquid_variable_audits",
      "foreignKey": "email_template_preview_liquid_variable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "EmailTemplatePreviewLiquidVariableAudit",
      "through": null
    },
    {
      "className": "DroppableRecord",
      "collectionName": null,
      "foreignKey": "droppable_record_id",
      "name": "droppable_record",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "EmailTemplatePreview",
      "collectionName": "email_template_previews",
      "foreignKey": "email_template_preview_id",
      "name": "email_template_preview",
      "macro": "belongs_to",
      "resource_name": "EmailTemplatePreview",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "automatic",
      "column": {
        "default": "1",
        "name": "automatic",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "droppable_record_id",
      "column": {
        "default": null,
        "name": "droppable_record_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "droppable_record_type",
      "column": {
        "default": null,
        "name": "droppable_record_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "email_template_preview_id",
      "column": {
        "default": null,
        "name": "email_template_preview_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "string_value",
      "column": {
        "default": null,
        "name": "string_value",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "variable_type",
      "column": {
        "default": "string",
        "name": "variable_type",
        "null": false,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "email_template_preview_liquid_variable",
  "primaryKey": "id"
}

/** Frontend model for EmailTemplatePreviewLiquidVariable. */
class EmailTemplatePreviewLiquidVariable extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  automatic() {
    return this.readAttributeUnderscore("automatic")
  }

  /** @returns {boolean} */
  hasAutomatic() {
    const value = this.automatic()

    return this._isPresent(value)
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  droppableRecordId() {
    return this.readAttributeUnderscore("droppable_record_id")
  }

  /** @returns {boolean} */
  hasDroppableRecordId() {
    const value = this.droppableRecordId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  droppableRecordType() {
    return this.readAttributeUnderscore("droppable_record_type")
  }

  /** @returns {boolean} */
  hasDroppableRecordType() {
    const value = this.droppableRecordType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  stringValue() {
    return this.readAttributeUnderscore("string_value")
  }

  /** @returns {boolean} */
  hasStringValue() {
    const value = this.stringValue()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  variableType() {
    return this.readAttributeUnderscore("variable_type")
  }

  /** @returns {boolean} */
  hasVariableType() {
    const value = this.variableType()

    return this._isPresent(value)
  }
}

export default EmailTemplatePreviewLiquidVariable
